export const distanceOptions = [
  { value: 1, label: '0-5' },
  { value: 2, label: '0-10' },
  { value: 3, label: '0-15' },
  { value: 4, label: '0-20' },
  { value: 5, label: '0-25' },
  { value: 6, label: '0-50' },
  { value: 7, label: '0-100' },
  { value: 8, label: '100+' },
]

export const attemptedAnsweredCallsOptions = [
  { value: 1, label: 'Attempted Calls' },
  { value: 2, label: 'Answered Calls' },
]

export const getDistanceRangeByValue = (value) => {
  switch (value) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
      const valueFromLabel = distanceOptions.find((option) => option.value == value)

      if (!valueFromLabel?.label) {
        return { from: null, to: null }
      }

      const [from, to] = valueFromLabel?.label.split('-')
      return { from, to }
    case 8:
      return { from: 100, to: null }

    default:
      return { from: null, to: null }
  }
}
